import React from "react";

import { getColumnName } from "../../../constants";
import SettingsPanel from "../../settings_panel";

import {ProductListHeadCell, ProductListHeadCellsParams} from "./types";

const getHeadCells = ({
  activeColumns,
  handleChangeColumn,
  hasGrossWeightManual,
  hasNetWeightManual,
  hasPalleteCnt,
  hasPalleteType,
  hasVolumeCartoon,
  hasVolumeManual,
  t,
}: ProductListHeadCellsParams): ProductListHeadCell[] => {
  const allColumns = [
    {
      id: 'id',
      numeric: false,
      disablePadding: true,
      label: getColumnName('id', t),
    },
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: getColumnName('name', t),
    },
    {
      id: 'pieces',
      numeric: false,
      disablePadding: true,
      label: getColumnName('pieces', t),
    },
    {
      id: 'places_manual',
      numeric: false,
      disablePadding: true,
      label: getColumnName('places_manual', t),
    },
    {
      id: 'pieces_in_cartoon',
      numeric: false,
      disablePadding: true,
      label: getColumnName('pieces_in_cartoon', t),
    },
    {
      id: 'unit_price',
      numeric: false,
      disablePadding: true,
      label: getColumnName('unit_price', t),
    },
    {
      id: 'price',
      numeric: false,
      disablePadding: true,
      label: getColumnName('price', t),
    },
    ...(hasVolumeCartoon
      ? [
        {
          id: 'volume_cartoon',
          numeric: false,
          disablePadding: true,
          label: getColumnName('volume_cartoon', t),
        }
      ]
      : []),
    ...(hasVolumeManual
      ? [
        {
          id: 'volume_manual',
          numeric: false,
          disablePadding: true,
          label: getColumnName('volume_manual', t),
        }
      ]
      : []),
    ...(hasNetWeightManual
      ? [
        {
          id: 'net_weight_manual',
          numeric: false,
          disablePadding: true,
          label: getColumnName('net_weight_manual', t),
        }
      ]
      : []),
    ...(hasGrossWeightManual
      ? [
        {
          id: 'gross_weight_manual',
          numeric: false,
          disablePadding: true,
          label: getColumnName('gross_weight_manual', t),
        }
      ]
      : []),
    {
      id: 'volume_total',
      numeric: false,
      disablePadding: true,
      label: getColumnName('volume_total', t),
    },
    {
      id: 'net_weight_cartoon',
      numeric: false,
      disablePadding: true,
      label: getColumnName('net_weight_cartoon', t),
    },
    {
      id: 'gross_weight_cartoon',
      numeric: false,
      disablePadding: true,
      label: getColumnName('gross_weight_cartoon', t),
    },
    {
      id: 'net_weight_total',
      numeric: false,
      disablePadding: true,
      label: getColumnName('net_weight_total', t),
    },
    {
      id: 'gross_weight_total',
      numeric: false,
      disablePadding: true,
      label: getColumnName('gross_weight_total', t),
    },
    ...(hasPalleteCnt
      ? [
        {
          id: 'pallete_cnt',
          numeric: false,
          disablePadding: true,
          label: getColumnName('pallete_cnt', t),
        }
      ]
      : []),
    ...(hasPalleteType
      ? [
        {
          id: 'pallete_type',
          numeric: false,
          disablePadding: true,
          label: getColumnName('pallete_type', t),
        }
      ]
      : []),
    {
      id: 'settings',
      numeric: true,
      disablePadding: true,
      noSort: true,
      label: <SettingsPanel
        handleSelect={handleChangeColumn}
        activeColumns={activeColumns}
        hasVolumeCartoon={hasVolumeCartoon}
        hasVolumeManual={hasVolumeManual}
        hasNetWeightManual={hasNetWeightManual}
        hasGrossWeightManual={hasGrossWeightManual}
        hasPalleteCnt={hasPalleteCnt}
        hasPalleteType={hasPalleteType}
      />,
    },
  ];

  return allColumns.filter((column) => activeColumns.includes(column.id));
}

export default getHeadCells
